import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/ProformaInvoice/components/SectionPurpose/SectionPurpose.module.scss';

const cn = classNames.bind(styles);

const SectionPurpose = (): ReactElement => {
  return (
    <section className={cn('purpose')}>
      <div className={cn('container')}>

        <div className={cn('purpose__section')}>

          <div className={cn('purpose__image-box')}>
            <picture>
              <source
                srcSet="
                /images/pages/Resources/FreightTemplates/sign-in.webp 1x,
                /images/pages/Resources/FreightTemplates/sign-in@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('purpose__image')}
                src="/images/pages/Resources/FreightTemplates/sign-in.webp"
                alt="bill of lading"
              />
            </picture>
          </div>

          <div className={cn('purpose__content')}>
            <h2 className={cn('purpose__heading')}>
              <span>Why use</span>{' '}
              <span>a Proforma?</span>
            </h2>
            <p className={cn('purpose__paragraph')}>
              It’s the blueprint for the transaction.
            </p>
            <ul className={cn('purpose__list')}>
              <li className={cn('purpose__list-item')}>
                <span>For the Buyer:</span>{' '}
                They can't just wire money internationally based on an email. Banks
                often require a Proforma to authorize a transfer or open a Letter of Credit.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>For Import Licenses:</span>{' '}
                In strict markets, you need to show a Proforma to the
                government to get permission to import the goods in the first place.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>For Forwarders:</span>{' '}
                It gives us the preliminary data we need to quote freight rates and
                check schedule availability.
              </li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SectionPurpose;